import { getInterFontWeightCSS, theme } from '@prophecy/theme';
import { Indicator, Root } from '@radix-ui/react-progress';
import styled, { css, keyframes } from 'styled-components';
import { tokens } from './tokens';
import { LabelPosition } from './types';
const labelPositionStyles = {
    [LabelPosition.right]: css `
    flex-direction: row;
    align-items: center;
    gap: ${theme.spaces.x12};
  `,
    [LabelPosition.bottom]: css `
    flex-direction: column;
    align-items: flex-end;
    gap: ${theme.spaces.x8};
  `
};
export const StyledProgressBarContainer = styled.div `
  position: relative;
  display: flex;
  justify-content: center;
  width: ${({ $width }) => $width};
  ${({ $labelPosition }) => ($labelPosition ? labelPositionStyles[$labelPosition] : '')}
`;
export const StyledRoot = styled(Root) `
  position: relative;
  z-index: ${theme.zLayer.m};
  overflow: hidden;
  width: 100%;
  height: ${({ height }) => height};
  border-radius: ${tokens.ProgressBar.size.borderRadius};
  background: ${tokens.ProgressBar.Content.backgroundColor};
`;
const indeterminateSlide = keyframes `
  0% { transform: translateX(-100%); }
  100% { transform: translateX(400%); }
`;
export const StyledIndicator = styled(Indicator) `
  background-color: ${({ $variant, $color }) => $color || tokens.ProgressBar[$variant].backgroundColor};
  height: 100%;
  transition: ${({ $variant }) => ($variant === 'indeterminate' ? 'none' : tokens.ProgressBar.Content.transition)};
  width: ${({ $value, $variant }) => ($variant === 'indeterminate' ? '30%' : `${$value}%`)};
  border-radius: ${tokens.ProgressBar.size.borderRadius};
  ${({ $variant }) => $variant === 'indeterminate' &&
    css `
      animation: ${indeterminateSlide} 1.5s ease-in-out infinite;
    `}
`;
export const StyledLabel = styled.span `
  position: relative;
  color: ${tokens.label.color};
  font-size: ${tokens.label.fontSize};
  ${getInterFontWeightCSS(tokens.label.fontWeight)};
`;
